<template>
  <div class="DataTables DeriveLibraryFormComponent ">

    <span v-if="isAll"><p>
      <b-spinner small label="alert" type="grow" variant="danger"></b-spinner> {{lang.infotext_3}}
    </p></span>
    <span v-if="blockCreateOver2Level"><p>
        <b-spinner small label="alert" type="grow" variant="danger"></b-spinner> {{lang.infotext_5}}
    </p></span>
    <span v-if="!isAll && !blockCreateOver2Level">
      <p>{{lang.infotext_1}}: {{categoryName}}</p>
      <LoaderComponent  v-if="!isData"></LoaderComponent>
      <div :id="id"></div>
      <!-- <p>{{lang.infotext_2}}:</p>
      <b-form-file
        class="library-files"
        v-model="libraryFiles"
        
        :placeholder="lang.filesPlaceholder"
        drop-placeholder="Drop file here..."
        multiple 
      ></b-form-file> 
      <br><br>-->
      <p>{{lang.infotext_4}}</p>
      <br><br>
      <p><b-badge class="badge badge-blue badge">Request</b-badge> - {{lang.infotext_2}}</p>
    </span>
  </div>
</template>
<script>
  import LibraryTypes from '@/constants/LibraryTypes'
  import LoaderComponent from "@/components/shared/LoaderComponent"


  export default {
    name: "DeriveLibraryFormComponent",
    props:{
      lang: Object,
      source: String
    },
    components: {

      LoaderComponent
    },
    data () {
      return {

        mainTable: "",
        id: "DeriveLibraryFormComponent",
        properties: [],
        partDatas: [],
        libraryTypes: [""],
        libraryFiles: null,
        
        listAllRevisionFiles: {},
        listAllImageTriggers: {},
      }
    },
    computed: {
      isAll(){
        if (this.$store.getters.selectedTreeLibraryItemObject.categoryId == 1){
          return true;
        }
        return false;
      },
      isData(){
        return this.properties.length != 0;
      },
      categoryId(){
        return this.$store.getters.selectedTreeLibraryItemObject.categoryId;
      },
      categoryName(){
        return this.$store.getters.selectedTreeLibraryItemObject.category;
      },
      revisionId(){
        
        // if (this.$store.getters.selectedRows.length == 0){
        //   this.back();
        //   return 
        // }
        return this.$route.query.revisionId;
      },
      variant(){
        if (this.$store.getters.s_skinVariant == "dark"){
          return "light";
        }else{
          return "dark";
        }
        
      },
      blockCreateOver2Level() {
        if (this.$store.getters.selectedTreeLibraryItemObject.depth == 2 ) {
          return true;
        } else {
          return false;
        }
      }
    },
    created () {
      

      this.getproperties();

    },
    watch: {
      categoryId: function(){

        this.getproperties();
      }

    },
    updated() {

    },
    mounted: function () {

    },
    methods: {
      back() {
        let to = this.$route.query.from;
        
        

        const query = {
          from: this.$route.path,
          to: to,

        }

        this.$router.push({ path: to, query: query });
      },
      setPackage(revisionId){
        
        let barValue = document.getElementById("barDetailValue_" + revisionId + "_" + this.id);
        if (barValue != null){
          let index = this.currentPackage[revisionId] + 1;
          barValue.value = this.packages[revisionId][this.currentPackage[revisionId]] + " (" + index + "/" + this.packages[revisionId].length +")";

          let leftbar = document.getElementById("leftbarDetail_" + revisionId + "_" + this.id);
          let rightbar = document.getElementById("rightbarDetail_" + revisionId + "_" + this.id);

          if (this.currentPackage[revisionId] == 0){
            leftbar.disabled = true;
          }else{
            leftbar.disabled = false;
          }
          
          if (this.currentPackage[revisionId] == this.packages[revisionId].length - 1){
            rightbar.disabled = true;
          }else{
            rightbar.disabled = false;
          }

                      
          
          for (var i = 0, le = this.packages[revisionId].length; i < le; i++) {
              var layer = "PACKAGES_"+this.packages[revisionId][i];

              if (i == this.currentPackage[revisionId]) {
                  if (this.place[revisionId].getElementsByClassName(layer)[0] != undefined) {
                      this.place[revisionId].getElementsByClassName(layer)[0].style["visibility"] = "visible";
                  }
                  

              } else {
                  if (this.place[revisionId].getElementsByClassName(layer)[0] != undefined) {
                      this.place[revisionId].getElementsByClassName(layer)[0].style["visibility"] = "hidden";
                  }
              }


          }
        }
      },
      buildSymbolViewer(doc, place, revisionId){

        let vue = this;
        
        let svg  = doc.firstChild

        this.place[revisionId] = place;

        
        let symbolbar = document.getElementById("bar_" + this.place[revisionId].id + "_" + this.id);
        
        symbolbar.innerHTML = "";
        
        let group = this.place[revisionId].getElementsByTagName(`g`);
        
        this.packages[revisionId] = [];
        this.currentPackage[revisionId] = 0;
        for (let i = 0, lei = group.length; i < lei; i++){
          
          let temp = group[i].className.baseVal.split("_");
          if (temp[0] == "PACKAGES"){
            
            this.packages[revisionId].push(temp[1])
          }
        }
  

        if(this.packages[revisionId].length > 1){
          
          this.symbolSvg = svg;

          
          
          
          
          let index = this.currentPackage[revisionId] + 1;
          let valueBar = this.packages[revisionId][this.currentPackage[revisionId]] + " (" + index + "/" + this.packages[revisionId].length +")";

          const bar = `<div role="group" class="input-group  input-group-sm">
                      <div class="input-group-prepend">
                      <button disabled="disabled" id="leftbarDetail_`+revisionId+"_"+this.id+`" type="button" class="btn btn-sm btn-`+this.variant+` btn-bar">&lt;</button>
                      </div> 
                      <input type="text" class="form-control form-control-sm" disabled="disabled" id="barDetailValue_`+revisionId+"_"+this.id+`" value="`+ valueBar +`" style="text-align:center;"> 
                      <div class="input-group-append">
                      <button id="rightbarDetail_`+revisionId+"_"+this.id+`" type="button" class="btn btn-sm btn-`+this.variant+` btn-bar">&gt;</button>
                      </div>
                      </div>`;

          symbolbar.innerHTML = bar;

          let leftbar = document.getElementById("leftbarDetail_" + revisionId + "_" + this.id);
          leftbar.addEventListener("click", function(e) {

            vue.currentRevisionId = revisionId;
            
            if (vue.currentPackage[revisionId] == 0){
              
            }else{
              
              vue.currentPackage[revisionId]--;
              vue.setPackage(revisionId);
            }
            
          })
          
          let rightbar = document.getElementById("rightbarDetail_" + revisionId + "_" + this.id);
          rightbar.addEventListener("click", function(e) {
            
            //vue.currentRevisionId = revisionId;

            if (vue.currentPackage[revisionId] == vue.packages[revisionId].length){
              
            }else{
              
              vue.currentPackage[revisionId]++;
              vue.setPackage(revisionId);
            }
            
          })

          


        }else{
            this.symbolSvg = {};
        }

        
        

      },
      async loadSVG(blob, id, revisionId){

        let svgData = await new Response(blob).text();
        
        let place = document.getElementById(id);

        //let temp = 
        
        if (place != null){
          
          place.innerHTML = "";

          var parser = new DOMParser();
          var doc = parser.parseFromString(svgData, "image/svg+xml");
          doc.documentElement.setAttribute("width", 200);
          doc.documentElement.setAttribute("height", 200);
                      
                        
          place.appendChild(doc.documentElement);

          //let pos = id.indexOf("symbol");
          if (place.dataset.type == LibraryTypes.PART || place.dataset.type == LibraryTypes.SYMBOL || place.dataset.type == LibraryTypes.HDLSYMBOL){
            
            this.buildSymbolViewer(doc, place, revisionId);
          }

          
        }
        
            
        
      },
      getproperties(){

        let vue = this;

        this.$store.dispatch(this.$store.getters.sectionPrefix + "_getLibraryType")
        .then(function(result) {
          
          console.log(result)

          if (result.status == "OK"){

            vue.libraryTypes = [""];
            result.data.forEach(element => {
                vue.libraryTypes.push(element.type);
            });

  
            let obj = {
              categoryId: vue.categoryId

            }

            vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_getProperties", obj)
            .then(function(result) {
              
              console.log(result)

              if (result.status == "OK"){

                vue.properties = result.data;
                //vue.propertiesRevNumbers.push(result.revision)
                vue.listAllImageTriggers[vue.revisionId] = false;


                vue.getDataForForm();
              }

            })


          }
        })

        

      },
      getDataForForm(){

        let vue = this;

        const obj = {
          revisionId: this.revisionId

        }

        this.$store.dispatch(this.$store.getters.sectionPrefix + "_getLibrary", obj)
        .then(function(result) {
          
          console.log(result)

          if (result.status == "OK"){

            result.data.sort(function(a, b){return a.priority-b.priority});

            vue.partDatas = result.data;



            vue.buildTable();
          }

        })

      },
      validateValues(obj) {
        
        let vue = this;

        let arr = [obj];

        this.$store.dispatch(this.$store.getters.sectionPrefix + "_createNewLibraryValidation", arr)
          .then((result) => {

            console.log(result);

            if (result.status == "OK") {
              if (result.data.valid == false) {


                for (let i = 0, lei = result.data.violatedRules.length; i < lei; i++) {

                  vue.displayValidationRules(result.data.violatedRules[i])
                }
              } else {
                vue.resetValidationRules(obj);
              }
            }



          })


      },
      displayValidationRules(obj) {

        let id = "value__" + obj.propertyId;
        let elem = document.getElementById(id);
        elem.classList.add("warning");

        let idInvalidFeedback = id + "__invalid";
        let elemInvalidFeedback = document.getElementById(idInvalidFeedback);
        elemInvalidFeedback.setAttribute("style", "display: block");
        elemInvalidFeedback.innerHTML = obj.message;

      },
      resetValidationRules(obj) {

        let id = "value__" + obj.propertyId;
        let elem = document.getElementById(id);
        elem.classList.remove("warning");

        let idInvalidFeedback = id + "__invalid";
        let elemInvalidFeedback = document.getElementById(idInvalidFeedback);
        elemInvalidFeedback.setAttribute("style", "display: none");
        elemInvalidFeedback.innerHTML = "";
      },
      checkFormValidationAfterLoad() {


        let editParts = document.getElementsByClassName('new-part');

        for (var i = 0; i < editParts.length; i++) {

          let temp = editParts[i].id.split("__")

          const validObj = {
            propertyId: temp[1],
            value: editParts[i].value,
          }
          this.validateValues(validObj);


        }

      },
      buildTable(){
        



        this.$store.dispatch("resetPropertyToSaving");

        for (let i = 0, lei = this.properties.length; i < lei; i++){
          let value = "";
          for (let j = 0, lej = this.partDatas.length; j < lej; j++){

            if (this.partDatas[j].id == this.properties[i].propertyId){

              this.properties[i].value = this.partDatas[j].value != null ? this.partDatas[j].value.display : "";
              
              break;
            }else{

              this.properties[i].value = "";
            }

          }


          let obj = {
            propertyId: this.properties[i].propertyId,
            value: this.properties[i].value,
            type: this.properties[i].type,
            isRequiredOnRequest: this.properties[i].isRequiredOnRequest
          }

          this.$store.dispatch("addPropertyToSaving", obj);



        }

        var tableplace = document.getElementById(this.id);
        if (tableplace == null) {
          return;
        }
        while (tableplace.firstChild) {
            tableplace.removeChild(tableplace.firstChild);
        }

        var table = document.createElement("table");
        table.setAttribute("id", "t_" + this.id);
        table.setAttribute("class", "table table-striped table-bordered");
        tableplace.appendChild(table)

        var tr = document.createElement("tr");

        var thead = document.createElement("thead");
        thead.appendChild(tr);

        table.appendChild(thead);

        let vue = this;


        let cols =  [
          { "data": "propertyId" },
          { "data": "priority" },
          { "data": "name" },
          { "data": "value" },

        ]

        let columns = [
          {
            name: "Id",
            alignInColumn: "left",

          },
          {
            name: "Priority",
            alignInColumn: "left",

          },
          {
            name: this.lang.table_header_Name,
            alignInColumn: "left",

          },
          {
            name: this.lang.table_header_Value,
            alignInColumn: "left",

          },



        ]




        var columnDefs = [];

        for (var i = 0, len = columns.length; i < len; i++){

          let classname = '_dt-body-'+ columns[i].alignInColumn;

          let  el = {
              targets: i,
              className: classname,
              render: function ( data, type, row, meta ) {
                if (data == null) {
                  data = "";
                }

                data = $.fn.dataTable.render.text().display(data);
                if (data.display != undefined) {
                  data.display = $.fn.dataTable.render.text().display(data.display);
                }

                if (meta.col == 1){
                  return data;
                }
                if (meta.col == 2){
                  let required = "<span class=\"required\">";
                  
                    if (row.isRequiredOnRequest == true){
                      required += "<b-badge class=\"badge badge-blue\">Request</b-badge>";
                    }
                    
                    required += "</span>"
                  
                  return data + "   " + required;
                }
                if (meta.col == 3){
                                        

                  if (row.type == "image"){
                    

                    if (data.display == ""){
                      return "<img src=\"/static/noimage.svg\" class=\"image-footprint\">";
                    }
                    

                    let barid = "bar_imageDetails__"+ vue.revisionId + "_" +  vue.id;
                    let bar = "<div id=\""+barid+"\" class=\"bar-symbol\"></div>";
                    
                    let id = "imageDetails__" + vue.revisionId;
                    let image = "<div id=\""+id+"\" class=\"image-footprint\"  data-type=\""+vue.libraryType+"\"></div>" + bar;

                    

                    const obj = {
                      type:  vue.libraryType,
                      name: data.display,
                      id: id,
                      revisionId: vue.revisionId
                    }
                    
                    if (data.display != ""){
                      
                      if(vue.listAllImageTriggers[vue.revisionId] === false){
                        vue.listAllImageTriggers[vue.revisionId] = true;
                        vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_getSvg", obj)
                        .then((result) => {
                          
                          if (result != null){
                            
                            
                            let id = result.id;                          
                                                
                            vue.loadSVG(result, id, vue.revisionId);
                            
                            
                          }
                        
                        })
                      }
                    }else{
                      image = data.display;
                    }
                                            
                    return image;
                  }else if (row.type == "text"){

                    let str = "";
                    str += "<div role=\"group\" class=\"input-group input-group-sm\">";
                    str += "<input data-type=\"" + row.type + "\" data-isRequiredOnRequest=\"" + row.isRequiredOnRequest + "\" data-type=\""+row.type+"\" class=\"form-control new-part\" type=\"text\" id=\"value__" + row.propertyId + "\" value=\"" + row.value + "\">";
                    str += "</div>";
                    str += "<datalist id=\"datalist__" + row.propertyId + "\" ></datalist>";
                    str += "<div class=\"invalid\" id=\"value__" + row.propertyId + "__invalid\"></div>";
            
                    return str;
                    
                  }else if (row.type == "library type"){
                    
                    let str = "";
                    str += "<div role=\"group\" class=\"input-group input-group-sm\">";
                    str += "<input data-type=\"" + row.type + "\" data-isRequiredOnRequest=\"" + row.isRequiredOnRequest + "\" data-type=\"" + row.type + "\" class=\"form-control new-part\" type=\"text\" id=\"value__" + row.propertyId + "\" value=\"" + row.value + "\" disabled=\"disabled\">";
                    str += "</div>";
                    str += "<datalist id=\"datalist__" + row.propertyId + "\" ></datalist>";
                    str += "<div class=\"invalid\" id=\"value__" + row.propertyId + "__invalid\"></div>";
                    
                    return str;
                  
                  
                  
                  }else if (row.type == "library number"){
                    
                    let str = "";
                    str += "<div role=\"group\" class=\"input-group input-group-sm\">";
                    str += "<input data-type=\"" + row.type + "\" data-isRequiredOnRequest=\"" + row.isRequiredOnRequest + "\" data-type=\"" + row.type + "\" class=\"form-control new-part\" type=\"text\" id=\"value__" + row.propertyId + "\" value=\"" + row.value + "\">";
                    str += "</div>";
                    str += "<datalist id=\"datalist__" + row.propertyId + "\" ></datalist>";
                    str += "<div class=\"invalid\" id=\"value__" + row.propertyId + "__invalid\"></div>";
                    
                    return str;

                  }else{
                    let str = "";
                    str += "<div role=\"group\" class=\"input-group input-group-sm\">";
                    str += "<input data-type=\"" + row.type + "\" data-isRequiredOnRequest=\"" + row.isRequiredOnRequest + "\" data-type=\""+row.type+"\" class=\"form-control new-part\" type=\"text\" id=\"value__" + row.propertyId + "\" value=\"" + row.value + "\">";
                    str += "</div>";
                    str += "<datalist id=\"datalist__" + row.propertyId + "\" ></datalist>";
                    str += "<div class=\"invalid\" id=\"value__" + row.propertyId + "__invalid\"></div>";
            
                    return str; 
                  }

                }

                return data;
              }
            }

          columnDefs.push(el);


          var th = document.createElement("th");
          tr.appendChild(th);
          
          var br = document.createElement("br");
          th.appendChild(br);
          var tx = document.createTextNode(columns[i].name)
          th.appendChild(tx);


        }


        var json = {};
        json.paging = false;
        json.info = false;
        json.dom = 'f<t>';
        json.data= this.properties;
        json.myColumnFormats = columns;
        json.select = false;
        json.columns = cols;
        json.columnDefs = columnDefs;
        json.order = [1, "asc"];
        json.initComplete = function () {

          vue.checkFormValidationAfterLoad();
        }

        if ($.fn.dataTable.isDataTable("#t_"+this.id)) {
            this.mainTable.destroy();
            
        }



        this.mainTable = $('#t_'+this.id).DataTable(json);


        this.mainTable.columns.adjust().draw();

        //hide first column in table
        this.mainTable.column( 0 ).visible( false );
        this.mainTable.column( 1 ).visible( false );

        //search input change view
        var searchplace = document.getElementById("t_" + this.id + "_filter").firstChild

        while (searchplace.firstChild) {

          if (searchplace.firstChild.textContent == "Search:"){
              searchplace.removeChild(searchplace.firstChild);
              break;
          }

        }

        searchplace.firstChild.setAttribute("placeholder", this.lang.placeholder_Search);
        searchplace.firstChild.setAttribute("class", "form-control form-control-sm")



        let editParts = document.getElementsByClassName('new-part');

        for (var i = 0; i < editParts.length; i++) {
          editParts[i].addEventListener('input', function (e){

            let temp = this.id.split("__");
            let propertyId = temp[1];
            let type = $(this).attr("data-type");
            let isRequiredOnRequest = $(this).attr("data-isRequiredOnRequest");

            let obj = {
              propertyId: propertyId,
              value: this.value,
              type: type,
              isRequiredOnRequest: isRequiredOnRequest
            }
            const validObj = {
              propertyId: propertyId,
              value: this.value,
            }
            vue.validateValues(validObj);

            vue.$store.dispatch("addPropertyToSaving", obj);
          })
        }


        


      },

    }

}
</script>
<style lang="scss">
  @import "./../../scss/_custom.scss";

  .DeriveLibraryFormComponent{
    table{

      padding: 0px !important;

    }
    table th {
      padding: 0rem !important;

      padding-left: 0.2rem !important;
      padding-right: 0.2rem !important;

    }
    table.dataTable thead th {
        position: relative;
        background-image: none !important;
    }
    table td {
      padding: 0.2rem !important;

    }

    .dataTables_filter{
      font-size: 10px;
    }
    .searcher{
      float: left;
    }
    .dataTables_filter .form-control-sm, .input-group-sm > .form-control{

      font-size: 0.7rem;
      line-height: 1;
      width: 200px;
    }
    ._dt-body-left{
      text-align: left;
    }
    ._dt-body-right{
      text-align: right;
    }
    ._dt-body-center{
      text-align: center;
    }
    .red{
      color: $red;
    }
    .red-img{
      background-color: $red;
      border: 0px;
    }
    .green{
      color: $green;
    }
    .green-img{
      background-color: $green;
      border: 0px;
    }
    .svg-image{
      background-color: white;
      margin: 10px;
      border: 1px solid #cccccc;
    }

    .btn{
      height: 26.8px;
    }
    td{
      word-break: break-all;
    }
    input-group{
      min-width: 200px;

    }
    input-group-prepend{
      height: 26.8px !important;
      widows: 24px;
    }
    .img-thumbnail{
      width: 100px;
    }
    .form-control{
      height: 26.8px;
    }
    .required{
      float: right;
      margin: 2px;
    }
    .type-select{
      padding-top: 5px;
      font-size: 0.7rem;
      padding-left: 5px;
    }
    .library-files{
      width: 60%;
    }
    .image-footprint{
      background-color: #ffffff;
      border: 1px solid #dee2e6;
      border-radius: 0.25rem;
      margin-bottom: 3px;
      margin-top: 3px;
      overflow: hidden;
      width: 200px;
      height: 200px;
    }
    .warning{
      border-color: $redfont !important;
    }
    .invalid{
      color: $redfont;
      font-size: 0.7rem;
      display: none;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/shared/DeriveLibraryFormComponent.vue